<template>
  <div class="mb-2">
    <div class="dashpending-wrap">
      <div class="dashpending-card-title" v-if="title">
        <h2>Pending Items</h2>
      </div>
      <div class="flex-container-wrap">
        <template v-if="!isEnrollPrime">
          <div v-if="isRestrictDownline" class="flex-item">
            <pending-block
                image-name="rep-reg.svg"
                class="mb-3 h-100"
                title="Edit Enrollments within 24hrs"
                :loading="isStatsLoading"
                :value="pendingStats.enrollments_24hrs_count || 0"
                :routeLink="{ name: 'Enrollments24hr' }"
            />
          </div>
        </template>
        <div class="flex-item"   v-if="displayCards">
          <pending-block
              image-name="signature.svg"
              title="Pending Customer Signature"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_document_count || 0"
              :routeLink="{ name: 'PendingSignatureList' }"
          />
        </div>
        <div class="flex-item"  v-if="displayCards">
          <pending-block
              image-name="reps.svg"
              title="Broker Registration in Progress"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_rep_administrator_count || 0"
              :routeLink="{ name: 'PendingRepRegistrationList' }"

          />
        </div>
        <div class="flex-item"  v-if="displayCards">
          <pending-block
              image-name="old.svg"
              title="Members turning 65+"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_member_turing_65_count || 0"
              :routeLink="{ name: 'PendingMember65List' }"
          />
        </div>
        <div class="flex-item" v-if="displayCards">
          <pending-block
              image-name="child.svg"
              title="Dependents turning 26"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_child_aging_off_count || 0"
              :routeLink="{ name: 'PendingDependentsChildList' }"
          />
        </div>
        <div class="flex-item">
          <pending-block
              image-name="enrollments.svg"
              title="Pending Enrollment in Process"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_enrollment_count || 0"
              :routeLink="{ name: 'PendingEnrollmentList' }"
          />
        </div>
        <div class="flex-item" v-if="displayCards">
          <pending-block
              image-name="group.svg"
              title="Group Registration in progress"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_group_registration_count || 0"
              :routeLink="{ name: 'PendingGroupRegistrationList' }"
          />
        </div>
        <div class="flex-item"  v-if="displayCards">
          <pending-block
              image-name="rep-reg.svg"
              title="Downline Pending Activation"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_downline_count || 0"
              :routeLink="{
            name: 'PendingDowlineRepList',
          }"
          />
        </div>
        <div class="flex-item"  v-if="displayCards">
          <pending-block
              image-name="reps.svg"
              title="Pending Underwriting List"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_underwriting_count || 0"
              :routeLink="{ name: 'PendingUnderwritingRepList'}"
          />
        </div>
        <div class="flex-item" v-if="displayCards">
          <pending-block
              image-name="spouse.svg"
              title="Deps turning 65 "
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_spouse_aging_off_count || 0"
              :routeLink="{ name: 'PendingDependentsSpouseList' }"
          />
        </div>
        <div class="flex-item" v-if="repInfo.enablePlanSwithOption && displayCards">
          <pending-block
              image-name="signature.svg"
              title="Pending Renewals"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.renewal_count || 0"
              :routeLink="{ name: 'PendingRenewals' }"
          />
        </div>

        <div class="flex-item" v-if="repInfo.enablePlanSwithOption && displayCards && planSwitchActive">
          <!---<pending-block
              image-name="signature.svg"
              title="Plan Change Eligible"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.plan_switch_count || 0"
              :routeLink="{ name: 'PlanSwitch' }"
          />-->
        </div>

        <div class="flex-item">
          <pending-block
              image-name="checkmark.svg"
              title="Pending Group Submission"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.pending_group_submission_count || 0"
              :routeLink="{ name: 'PendingSubmission'}"
          />
        </div>
        <div class="flex-item" v-if="displayCards && isL713Rep">
          <pending-block
              image-name="old.svg"
              title="Active Members (65 or Older)-L713 Medical Plan"
              class="mb-3 h-100"
              :loading="isStatsLoading"
              :value="pendingStats.active_members_65_l713 || 0"
              :routeLink="{ name: 'l713ActiveMembers'}"
          />
        </div>
        <div class="flex-item" v-if="displayCards &&pendingStats.pending_group_renewals">
          <pending-block
              image-name="group.svg"
              title="Group Renewals - (Upcoming 30/60/90 days)"
              :value="pendingStats.pending_group_renewals"
              :loading="isStatsLoading"
              class="mb-3 h-100"
              :routeLink="{ name: 'pendingGroupRenewals'}"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Api from "@/resource/Api";
import { mapGetters } from "vuex";
import PendingBlock from "@/components/ui/PendingBlock.vue";
import helper from "@/resource/Helper";
import {restrictedReps} from "@/utils/constant";
import isEnrollPrimeUtil from '@/utils/isEnrollPrimeUtil';
import {baseApiUrl} from "../../../resource/EndPoints/endpoints";
import axios from "axios";
export default {
  components: { PendingBlock },
  name: "PendingItemsInterval",
  props: {
    title: {
      required: false,
      default: true,
    },
  },
  data: () => ({
    pendingScroll: {
      vuescroll: {
        mode: "native",
        wheelScrollDuration: "600",
      },
      scrollPanel: {
        maxHeight: 400,
      },
      bar: {
        background: "#ddd",
      },
    },
    isRestrictDownline:false,
    // stats: null,
    isEnrollPrimeUtil
  }),
  computed: {
    ...mapGetters({
      pendingStats: "pendingStats",
      repInfo: "rep",
      isStatsLoading: "isStatsLoading"
    }),
    class() {
      return true;
    },
  isL713Rep() {
    return this.$store.getters.isL713Rep
  },
    planSwitchActive(){
    return this.$store.getters.planSwitchActive
  },
    displayCards() {
      if (restrictedReps.includes(this.repCode)) {
        return false;
      }
      return true;
    },
    isEnrollPrime() {
      return isEnrollPrimeUtil.isEnrollPrime();
    },
  },
  methods: {
    checkRenewalsStatus() {
      return helper.checkRenewalsId(this.repInfo.id, this.$endpoint.RENEWALS_STATIC_ID);
    },
    async fetchPendingStats() {
      try {
        await this.$store.dispatch('dashboard/getPendingStats');
      } catch (error) {
        console.error('Failed to fetch pending stats:', error);
      }
    },
    getRestrictDownlineFlag() {
      let loader = this.$loading.show();
      let url = `${baseApiUrl}api/v2/rep-downline-restriction`
      let payload = {
        rep_id: this.repId
      }
      axios.post(url, payload)
          .then((res) => {
            this.isRestrictDownline = res.data.access
          })
          .catch(() => {
            console.log("Something went wrong!");
          })
          .finally(() => {
            loader.hide();
          });
    }
  },
  created() {
    this.fetchPendingStats();
    this.getRestrictDownlineFlag();
  }
};
</script>
<style>
  .pending-content {
    min-height: 30px !important;
  }

  .dashpending-wrap .flex-container-wrap .flex-item{
    flex-grow: 1;
    width: 200px;
  }
  .dashpending-wrap .flex-container-wrap .last-block {
    flex-grow: 5;
    width: 800px;
  }
  .dashpending-wrap .flex-container-wrap .flex-item .pending-blocks{
    width: auto !important;
  }
  @media (min-width: 1440px) {
    .dashpending-wrap .flex-container-wrap .flex-item{
      flex-grow: 1;
      max-width: 230px;
    }
    .dashpending-wrap .flex-container-wrap .last-block{
      display: none;
    }
  }
  @media (max-width: 1024px) {
    .dashpending-wrap .flex-container-wrap .last-block{
      width: 190px;
      flex-grow: 1.2;
    }
  }
  @media (max-width: 768px) {
    .dashpending-wrap .flex-container-wrap .last-block{
      flex-grow: 2;
    }
  }
  @media (max-width: 713px) {
    .dashpending-wrap .flex-container-wrap .last-block{
      flex-grow: 1.1;
    }
  }
  @media (max-width: 503px) {
    .dashpending-wrap .flex-container-wrap .last-block{
      display: none;
    }
  }
</style>